module.exports = __webpack_public_path__ + "img/private-new-knowledge.91504427.png";